const $el = {
    productsSlider: $('.section-products-container'),
    testimonialSlider: $('.section-testimonials__slider'),
    ingredientsPowerSlider: $('.ingredients-power__slide'),
    ingredientsGridIcons: $('.ingredients-grid-icons__mobile-slider'),
    ingredientsInsideSlider: $('.ingredients-inside__slider'),
    sliderSplash: $('.slider-splash__slider.mobile-tablet-only'),
    sliderSplashDesktop: $('.slider-splash__slider.desktop-only')
}


/* Icon Product Slider Section */
if ($el.productsSlider.length > 0) {
    $el.productsSlider.slick({
        infinite: false,
        dots: false,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    infinite: false,
                    dots: false,
                    centerMode: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 990,
                settings: {
                    infinite: false,
                    dots: true,
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });
}

/* Testimonial Slider Section */
if ($el.testimonialSlider.length > 0) {
    $el.testimonialSlider.slick({
        infinite: false,
        dots: false,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    infinite: false,
                    dots: false,
                    centerMode: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 990,
                settings: {
                    infinite: false,
                    dots: true,
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });
}

/* Ingredients Mobile Slider */
if ($el.ingredientsGridIcons.length > 0) {
    $el.ingredientsGridIcons.slick({
        infinite: false,
        dots: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    infinite: false,
                    dots: false,
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 990,
                settings: {
                    infinite: false,
                    dots: true,
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });
}

/* Ingredients Power Slider */
if ($el.ingredientsInsideSlider.length > 0) {
    $el.ingredientsInsideSlider.slick({
        infinite: true,
        dots: false,
        centerMode: true,
        centerPadding: '100px',
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    infinite: true,
                    dots: false,
                    centerMode: true,
                    centerPadding: '80px',
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 990,
                settings: {
                    infinite: true,
                    dots: true,
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });
}

/* Slider Splash Section */
if ($el.sliderSplash.length > 0) {
    $el.sliderSplash.slick({
        infinite: true,
        dots: false,
        centerMode: false,
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 1140,
                settings: {
                    infinite: true,
                    dots: false,
                    centerMode: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 750,
                settings: {
                    infinite: true,
                    dots: true,
                    centerMode: true,
                    centerPadding: '100px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 400,
                settings: {
                    infinite: true,
                    dots: true,
                    centerMode: true,
                    centerPadding: '85px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });
}

if ($el.sliderSplashDesktop.length > 0) {
    $el.sliderSplashDesktop.slick({
        infinite: false,
        dots: false,
        centerMode: false,
        slidesToShow: 7,
        slidesToScroll: 1,
        initialSlide: 7,
        arrows: false
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        let currentIndex = nextSlide + 3;
        hideAllSliderSplashDesktop();
        $($el.sliderSplashDesktop.find('.slider-splash__slide[data-slick-index="' + currentIndex + '"] .slider-splash__slide-content')).css('opacity', 1);

        $('.slider-splash__slide[data-slick-index="' + parseInt(currentIndex - 3 ) + '"]').addClass('first');
        $('.slider-splash__slide[data-slick-index="' + parseInt(currentIndex - 2 ) + '"]').addClass('second');
        $('.slider-splash__slide[data-slick-index="' + parseInt(currentIndex - 1 ) + '"]').addClass('third');
        $('.slider-splash__slide[data-slick-index="' + parseInt(currentIndex) + '"]').addClass('fourth');
        $('.slider-splash__slide[data-slick-index="' + parseInt(currentIndex + 1 ) + '"]').addClass('fifth');
        $('.slider-splash__slide[data-slick-index="' + parseInt(currentIndex + 2 )+ '"]').addClass('sixth');
        $('.slider-splash__slide[data-slick-index="' + parseInt(currentIndex + 3 ) + '"]').addClass('seventh');
    });

    $($el.sliderSplashDesktop.find('.slider-splash__slide[data-slick-index="7"]')).addClass('first');
    $($el.sliderSplashDesktop.find('.slider-splash__slide[data-slick-index="8"]')).addClass('second');
    $($el.sliderSplashDesktop.find('.slider-splash__slide[data-slick-index="9"]')).addClass('third');
    $($el.sliderSplashDesktop.find('.slider-splash__slide[data-slick-index="10"]')).addClass('fourth');
    $($el.sliderSplashDesktop.find('.slider-splash__slide[data-slick-index="11"]')).addClass('fifth');
    $($el.sliderSplashDesktop.find('.slider-splash__slide[data-slick-index="12"]')).addClass('sixth');
    $($el.sliderSplashDesktop.find('.slider-splash__slide[data-slick-index="13"]')).addClass('seventh');
    $($el.sliderSplashDesktop.find('.slider-splash__slide[data-slick-index="10"] .slider-splash__slide-content')).css('opacity', 1);

    $('.slider-splash__slide_left_side').click(function(){
        $el.sliderSplashDesktop.slick('slickPrev');
        console.log('left click');
    });
    $('.slider-splash__slide_right_side').click(function(){
        $el.sliderSplashDesktop.slick('slickNext');
        console.log('right click');
    });

    $('.slider-splash__slide-prev').on('click', function () {
        $el.sliderSplashDesktop.slick("slickPrev");
    });
    $('.slider-splash__slide-next').on('click', function () {
        $el.sliderSplashDesktop.slick("slickNext");
    });
}

const hideAllSliderSplashDesktop = () => {
    $('.slider-splash__slider.desktop-only .slider-splash__slide-content').css('opacity', 0);
    $($el.sliderSplashDesktop.find('.slider-splash__slide')).removeClass('first second third fourth fifth sixth seventh');
}

/* Slider Splash Add to Cart */
document.addEventListener('DOMContentLoaded', function() {
    const addToCartButtons = document.querySelectorAll('.add-to-cart-variant');

    addToCartButtons.forEach(button => {
        button.addEventListener('click', function(event) {
            event.preventDefault();
            const variantId = this.getAttribute('data-variant-id');

            addItemToCart(variantId);
        });
    });

    function addItemToCart(variantId, quantity = 1) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: [{
                    id: variantId,
                    quantity: quantity
                }]
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log('Item added to cart:', data);
            })
            .catch((error) => {
                console.error('Error adding item to cart:', error);
            });
    }
});

/* Stau.ai Fixes */
document.addEventListener('DOMContentLoaded', function() {
    const submitButton = document.querySelector('body[class*="product"] .product-form__submit');
    const labelElement = document.querySelector('label.rtx-subscription-label.one-time');
    const labels = document.querySelectorAll('.rtx-subscription-label:not(.one-time)');

    if (submitButton) {
        submitButton.addEventListener('click', function(event) {
            event.preventDefault();

            const urlParams = new URLSearchParams(window.location.search);
            const sellingPlanId = urlParams.get('selling_plan');
            const variantId = document.querySelector('.product-variant-id').value;

            let itemToAdd = {
                id: variantId,
                quantity: 1
            };

            if (sellingPlanId) {
                itemToAdd.selling_plan = sellingPlanId;
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [itemToAdd]
                })
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Item added to cart:', data);
                    // window.location.href = "/cart"

                    const SmartCart = window.Rebuy.SmartCart;
                    if (SmartCart){
                        SmartCart.enrich();
                        SmartCart.show();
                    }
                    // Might be deprecated
                    //if (window.Rebuy && window.Rebuy.Cart) {
                    //    Rebuy.Cart.fetchCart();
                    //}
                })
                .catch(error => {
                    console.error('Error adding item to cart:', error);
                });
        });
    }

    if (labelElement) {
        labelElement.addEventListener('click', function() {
            const url = new URL(window.location.href);
            url.searchParams.delete('selling_plan');
            window.history.replaceState({}, '', url.toString());
        });
    }


    labels.forEach(label => {
        label.addEventListener('click', function() {
            const selectElement = document.querySelector('.rtx-subscription-box select[name="selling_plan"]');

            if (selectElement) {
                const selectedValue = selectElement.value;
                const url = new URL(window.location.href);
                url.searchParams.set('selling_plan', selectedValue);
                window.history.pushState({}, '', url.toString());
            }
        });
    });


});

/* PDP Reel Up Fixes */
document.addEventListener('DOMContentLoaded', function() {
    const productPage = document.querySelector('body[class*="product"]');

    if (productPage) {
        const intervalId = setInterval(() => {
            const sliderHeading = document.querySelector('.reelUp_slider_heading');
            if (sliderHeading && sliderHeading.innerHTML !== 'How Do You <strong>PureBoost</strong>?') {
                sliderHeading.innerHTML = 'How Do You <strong>Pureboost</strong>?';
            }

            const verifiedLink = document.querySelector('.reelUp_verified_link');
            if (verifiedLink) {
                verifiedLink.remove();
                clearInterval(intervalId);
            }
        }, 1000);
    }
});

/* Smooth Scroll */
document.addEventListener('DOMContentLoaded', function() {
    const anchors = document.querySelectorAll('a[href^="#"]:not(.add-to-cart-variant):not(#recovery-link)');

    anchors.forEach(anchor => {
        anchor.addEventListener('click', function(event) {
            event.preventDefault();

            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            targetElement.scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
